import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Element from '../../../Components/SelectElement/Element';
import { setFormSelectItem, setFormState } from '../../../redux/form';
import { closeModal } from '../../../redux/modal';
import { numberAddComma } from '../../../common/util';
import DefaultModalLayout from './../../../Layouts/ModalLayouts/DefaultModalLayout';
import { FuneralItemTypes } from './../../../redux/funeralItem';
import { FormTypes } from './../../../redux/form';

const key = 'room';
function SelectRoom() {
    const dispatch = useDispatch();

    const rooms = useSelector(
        (state) => state.funeralItem[FuneralItemTypes.OPTIONS].room
    );
    const { roomId } = useSelector(
        (state) => state.form[FormTypes.FUNERAL_ESTIMATE]
    );

    return (
        <DefaultModalLayout header={{ content: '빈소 선택', props: {} }}>
            {rooms.map((ele, idx) => {
                const { optionId, name, price } = ele;

                const hourPrice = parseInt(price / 24);

                return (
                    <Element
                        key={optionId}
                        selected={roomId === optionId}
                        name={name}
                        extra={
                            <>
                                {numberAddComma(price)}원 / 1일 (
                                {numberAddComma(hourPrice)}원/1시간)
                            </>
                        }
                        onClick={() => {
                            dispatch(
                                setFormState({
                                    type: FormTypes.FUNERAL_ESTIMATE,
                                    prop: key + 'Id',
                                    data: optionId,
                                })
                            );
                            dispatch(
                                setFormSelectItem({
                                    type: FormTypes.FUNERAL_ESTIMATE,
                                    prop: key,
                                    data: ele,
                                })
                            );
                            dispatch(closeModal());
                        }}
                    />
                );
            })}
        </DefaultModalLayout>
    );
}

export default SelectRoom;
